import React from 'react'
import VerifyEmailComp from '../components/verifyEmailComp/VerifyEmailComp'

const VerifyEmail = () => {
  return (
    <VerifyEmailComp />
  )
}

export default VerifyEmail